import { render } from "./ReportsManager.vue?vue&type=template&id=c06c08ec"
import script from "./ReportsManager.vue?vue&type=script&lang=js"
export * from "./ReportsManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__